<template>
  <div>
    <InvoicePreview v-if="isInvoiceReady" :invoice="invoice">
      <template v-slot:top>
        <v-card-actions>
          <v-btn color="primary" text :to="{name: 'shipment-page', params: {id: invoice.shipment.id}}">Открыть поставку</v-btn>
          <v-btn color="primary" text @click="onPrintClicked">Распечатать</v-btn>

          <v-spacer/>

          <template v-if="allowExecutorSignButton || allowCustomerSignButton">
            <template v-if="$store.getters.isCertificateLoaded">
              <v-btn color="primary" @click="onSignClicked()" text> Подписать</v-btn>
            </template>
            <template v-else>
              <v-btn color="primary" text @click="selectCertificateModal = true"> Подписать</v-btn>

              <v-dialog v-model="selectCertificateModal" max-width="480" :persistent="true">
                <v-card>
                  <v-toolbar color="primary" dark flat>
                    <v-toolbar-title> Выбор ключа</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <ActivateCertificate @cancel="selectCertificateModal = false" @activated="onSigningCertificateSelected()"/>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn color="secondary" text @click="selectCertificateModal = false"> Отменить</v-btn>
                  </v-card-actions>
                </v-card>

              </v-dialog>
            </template>
          </template>
          <template v-if="allowInvoiceDeleteButton">
            <v-btn text color="error" @click="deleteDialog = true">Удалить</v-btn>

            <v-dialog v-model="deleteDialog" max-width="480" :persistent="true">
              <v-card>
                <v-card-title class="headline"> Удаление счет-фактуры</v-card-title>
                <v-card-text><v-textarea v-model="comment" outlined :dense="true" label="Причина удаления" no-resize row-height="12" clearable :disabled="isLoading"/></v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="warning darken-1" text @click="deleteDialog = false"> Отменить</v-btn>

                  <template v-if="invoice.isExecutorApproved">
                    <template v-if="$store.getters.isCertificateLoaded">
                      <v-btn color="error darken-1" text @click="cancelInvoice()"> Удалить</v-btn>
                    </template>
                    <template v-else>
                      <v-btn color="error darken-1" text @click="selectCertificateModal = true"> Удалить</v-btn>
                      <v-dialog v-model="selectCertificateModal" max-width="480" :persistent="true">
                        <v-card>
                          <v-toolbar color="primary" dark flat>
                            <v-toolbar-title> Выбор ключа</v-toolbar-title>
                          </v-toolbar>
                          <v-card-text>
                            <ActivateCertificate @cancel="selectCertificateModal = false" @activated="cancelInvoice(); deleteDialog = false;"/>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer/>
                            <v-btn color="warning" text @click="selectCertificateModal = false"> Отменить</v-btn>
                          </v-card-actions>
                        </v-card>

                      </v-dialog>
                    </template>
                  </template>
                  <template v-else>
                    <v-btn color="error darken-1" text @click="deleteInvoice()"> Удалить</v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>

          <v-snackbar v-model="successSignedSnackbar" top :timeout="3000" color="success" :counter="9">
            Документ успешно подписан
            <v-btn color="white" text @click="successSignedSnackbar = false"> Закрыть</v-btn>
          </v-snackbar>

          <v-snackbar v-model="successCanceledSnackbar" top :timeout="3000" color="success" :counter="9">
            Документ успешно отменён
            <v-btn color="white" text @click="successCanceledSnackbar = false"> Закрыть</v-btn>
          </v-snackbar>

          <v-snackbar v-model="signFailedSnackbar" top :timeout="3000" color="error" :counter="9">
            Ошибка при подписании документа
            <v-btn color="white" text @click="signFailedSnackbar = false"> Закрыть</v-btn>
          </v-snackbar>

          <v-snackbar v-model="cancelFailedSnackbar" top :timeout="3000" color="error" :counter="9">
            Ошибка при удалении документа
            <v-btn color="white" text @click="cancelFailedSnackbar = false"> Закрыть</v-btn>
          </v-snackbar>

          <v-snackbar v-model="supplierNotSignedSnackbar" top :timeout="3000" color="warning" :counter="9">
            Документ не подписан поставщиком
            <v-btn color="white" text @click="supplierNotSignedSnackbar = false"> Закрыть</v-btn>
          </v-snackbar>

          <v-snackbar v-model="signBalanceIsLowSnackbar" top :timeout="3000" color="warning" :counter="9">
            Недостаточно баланса на счёту
            <v-btn color="white" text @click="signBalanceIsLowSnackbar = false"> Закрыть</v-btn>
          </v-snackbar>

          <v-snackbar v-model="signCreditLimitIsLow" top :timeout="3000" color="warning" :counter="9">
            Недостаточно кредита
            <v-btn color="white" text @click="signCreditLimitIsLow = false"> Закрыть</v-btn>
          </v-snackbar>

          <v-snackbar v-model="signSignatureValidationFailed" top :timeout="3000" color="warning" :counter="9">
            Подпись не прошла проверку
            <v-btn color="white" text @click="signSignatureValidationFailed = false"> Закрыть</v-btn>
          </v-snackbar>

          <v-snackbar v-model="signRoamingSignatureValidationFailed" top :timeout="3000" color="warning" :counter="9">
            Подпись не прошла проверку налогового комитета
            <v-btn color="white" text @click="signRoamingSignatureValidationFailed = false"> Закрыть</v-btn>
          </v-snackbar>

          <v-snackbar v-model="signRoamingServiceProcessingError" top :timeout="3000" color="warning" :counter="9">
            Ошибка при обработке на сервере налогового комитета
            <v-btn color="white" text @click="signRoamingServiceProcessingError = false"> Закрыть</v-btn>
          </v-snackbar>
        </v-card-actions>

        <v-divider/>
      </template>
    </InvoicePreview>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import ActivateCertificate from '@/components/main/sign/ActivateCertificate'
import InvoiceService from '@/services/invoice.service';
import SignService from '@/services/sign/sign.service';
import EImzo from '@/plugins/eimzo'
import * as SignActionResult from '@/enum/SignActionResultCode'
import InvoicePreview from "@/components/main/invoice/InvoicePreview";
import Mapper from "@/helpers/mappers"
import {CustomerDeclined, InvoiceCanceled, InvoiceDeleted,InvoiceSend} from "@/enum/InvoiceStatus";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";

export default {
  name: "InvoiceView",
  components: {
    InvoicePreview,
    ActivateCertificate
  },

  data() {
    return {
      invoice: null,
      isLoading: false,

      signUrl: null,
      signDialog: false,

      selectCertificateModal: false,

      successCanceledSnackbar: false,
      successSignedSnackbar: false,
      signFailedSnackbar: false,
      supplierNotSignedSnackbar: false,
      cancelFailedSnackbar: false,

      signBalanceIsLowSnackbar: false,
      signCreditLimitIsLow: false,
      signSignatureValidationFailed: false,
      signRoamingSignatureValidationFailed: false,
      signRoamingServiceProcessingError: false,

      deleteDialog: false,
      cancelDialog: false
    };
  },
  computed: {
    allowInvoiceDeleteButton() {
      return this.isInvoiceReady
          && this.isWeExecutor
          && !this.invoice.isCustomerApproved
          && this.invoice.status !== InvoiceDeleted
          && this.invoice.status !== InvoiceCanceled
          && this.invoice.status !== CustomerDeclined
          && this.invoice.status !== InvoiceSend;
    },

    isWeCustomer() {
      return this.isInvoiceReady
          && this.invoice.customerDetails.inn === this.$store.getters.login.company.inn;
    },
    isWeExecutor() {
      return this.isInvoiceReady
          && this.invoice.executorDetails.inn === this.$store.getters.login.company.inn;
    },
    allowExecutorSignButton() {
      return this.isInvoiceReady
          && this.isWeExecutor
          && !this.invoice.isExecutorApproved
          && this.invoice.status !== InvoiceDeleted;
    },
    allowCustomerSignButton() {
      return this.isInvoiceReady
          && this.isWeCustomer
          && this.invoice.isExecutorApproved
          && !this.invoice.isCustomerApproved
          && !this.invoice.shipment.isDeclined
          && this.invoice.status !== InvoiceDeleted;
    },

    isInvoiceReady() {
      return this.invoice !== null;
    }
  },

  methods: {
    onPrintClicked() {
      if (this.isInvoiceReady)
        InvoiceService.printPdf(this.invoice.id);
    },
    onSignClicked() {
      const vm = this;

      this.isLoading = true;
      InvoiceService.getSignProperties(this.invoice.id)
          .then(getSignPropertiesResponse => {
            if (getSignPropertiesResponse.data.HashDetail) {
              const timestampFn = (signatureHex) => {
                return new Promise((resolve, reject) => {
                  SignService.getTimeStamp(signatureHex)
                      .then(getTimeStampResponse => {
                        resolve(getTimeStampResponse.data);
                      }, reject);
                })
              };

              if (vm.isWeExecutor) {
                const fakturaHashCode = getSignPropertiesResponse.data.HashDetail.FakturaHashCode;
                const roamingHashCode = getSignPropertiesResponse.data.HashDetail.RoamingOwnerHashCode;

                if (roamingHashCode) {
                  EImzo.sign(fakturaHashCode, roamingHashCode, vm.$store.getters.certificate, timestampFn)
                      .then(result => {
                        const signResult = result[0];
                        const attachTimestampResult = result[1];

                        SignService.signInvoiceByExecutor(vm.invoice.id, {
                          fakturaPkcs7: signResult.pkcs7,
                          roamingPkcs7: attachTimestampResult.pkcs7,
                          certificateSerial: attachTimestampResult.signerSeriaNumber
                        })
                            .then(response => {
                              if (response.data === SignActionResult.Success) {
                                vm.successSignedSnackbar = true;
                                vm.loadInvoiceInfo();
                              } else if (response.data === SignActionResult.BalanceIsLow) {
                                vm.signBalanceIsLowSnackbar = true;
                              } else if (response.data === SignActionResult.CreditLimitIsLow) {
                                vm.signCreditLimitIsLow = true;
                              } else if (response.data === SignActionResult.SignatureValidationFailed) {
                                vm.signSignatureValidationFailed = true;
                              } else if (response.data === SignActionResult.RoamingSignatureValidationFailed) {
                                vm.signRoamingSignatureValidationFailed = true;
                              } else if (response.data === SignActionResult.RoamingServiceProcessingError) {
                                vm.signRoamingServiceProcessingError = true;
                              } else {
                                vm.signFailedSnackbar = true;
                              }
                            }, () => {
                              vm.signFailedSnackbar = true;
                            })
                            .finally(() => {
                              vm.isLoading = false;
                            })
                      }, () => {
                        vm.signFailedSnackbar = true;
                        vm.isLoading = false;
                      });
                } else {
                  vm.supplierNotSignedSnackbar = true;
                  vm.isLoading = false;
                }
              } else {
                const fakturaHashCode = getSignPropertiesResponse.data.HashDetail.FakturaHashCode;
                const roamingHashCode = getSignPropertiesResponse.data.HashDetail.RoamingContractorHashCode;

                if (roamingHashCode) {
                  EImzo.signByAttach(fakturaHashCode, roamingHashCode, vm.$store.getters.certificate, timestampFn)
                      .then(result => {
                        const signResult = result[0];
                        const attachTimestampResult = result[1];

                        SignService.signInvoiceByCustomer(vm.invoice.id, {
                          fakturaPkcs7: signResult.pkcs7,
                          roamingPkcs7: attachTimestampResult.pkcs7,
                          certificateSerial: attachTimestampResult.signerSeriaNumber
                        })
                            .then(() => {
                              vm.successSignedSnackbar = true;
                              vm.loadInvoiceInfo();
                            }, () => {
                              vm.signFailedSnackbar = true;
                            })
                            .finally(() => {
                              vm.isLoading = false;
                            })
                      }, () => {
                        vm.signFailedSnackbar = true;
                        vm.isLoading = false;
                      });
                } else {
                  vm.supplierNotSignedSnackbar = true;
                  vm.isLoading = false;
                }
              }
            } else {
              vm.signFailedSnackbar = true;
              vm.isLoading = false;
            }
          }, () => {
            vm.signFailedSnackbar = true;
            vm.isLoading = false;
          });
    },

    loadInvoiceInfo() {
      const id = this.$route.params.id;

      this.isLoading = true;
      this.invoice = null;
      this.$store.dispatch(LAYOUT_LOADING_START);

      InvoiceService.getInfo(id)
          .then(response => {
            this.invoice = Mapper.mapInvoiceInfo(response.data)
          }, () => {
            this.$router.go(-1);
          })
          .catch(ex => {
            window.console.log(ex)
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP);
            this.isLoading = false;
          })
    },

    onSigningCertificateSelected() {
      this.onSignClicked();
    },
    deleteInvoice() {
      this.isLoading = true;
      let data = {
        Comment:this.comment
      }
      InvoiceService.delete(this.invoice.id, data)
          .then(() => {
            this.$router.push({
              name: 'shipment-page',
              params: {id: this.invoice.shipment.id}
            });
            this.deleteDialog = false;
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    cancelInvoice() {
      this.isLoading = true;
      SignService.getCancelHashCode(this.invoice.id)
          .then(getCancelHashCodeResponse => {
            const timestampFn = (signatureHex) => {
              return new Promise((resolve, reject) => {
                SignService.getTimeStamp(signatureHex)
                    .then(getTimeStampResponse => {
                      resolve(getTimeStampResponse.data);
                    }, reject);
              })
            };
            const fakturaCancelHashCode = getCancelHashCodeResponse.data.FakturaCancelHashCode;
            const roamingCancelHashCode = getCancelHashCodeResponse.data.RoamingCancelHashCode;

            if (roamingCancelHashCode) {
              EImzo.sign(fakturaCancelHashCode, roamingCancelHashCode, this.$store.getters.certificate, timestampFn)
                  .then(result => {
                    const signResult = result[0];
                    const attachTimestampResult = result[1];

                    SignService.cancelInvoice(this.invoice.id, {
                      fakturaPkcs7: signResult.pkcs7,
                      roamingPkcs7: attachTimestampResult.pkcs7,
                      certificateSerial: attachTimestampResult.signerSeriaNumber
                    })
                        .then(() => {
                          this.$router.push({
                            name: 'shipment-page',
                            params: {id: this.invoice.shipment.id}
                          });
                          this.deleteDialog = false;
                        }, () => {
                          this.cancelFailedSnackbar = true;
                        })
                        .finally(() => {
                          this.isLoading = false;
                        });
                  }, () => {
                    this.cancelFailedSnackbar = true;
                    this.isLoading = false;
                  });
            } else {
              this.cancelFailedSnackbar = true;
              this.isLoading = false;
            }
          }, () => {
            this.cancelFailedSnackbar = true;
            this.isLoading = false;
          })
    }
  },
  watch: {
    "$route": function () {
      this.loadInvoiceInfo();
    }
  },
  mounted() {
    this.loadInvoiceInfo();
  }
}
</script>